import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { ICategoryAppAction, getData, selectItem, tabAction, hideAction, ICategoryAppStoreState } from '@/redux/ui/category-app';

interface IProps {
    lvList1: any[];
    lvList2: any[];
    lvList3: any[];
    lvList4: any[];
    lvIndex1: number;
    lvIndex2: number;
    lvIndex3: number;
    lvIndex4: number;
    tabIndex: number;
    visible: boolean;
    hideAction() :void;
    selectItem(index: number, k: number): void;
    tabAction(index: number): void;
    getData(): any;
};

class CategoryApp extends React.Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
  }
  public componentDidMount() {
    this.props.getData();
  }

  public render() {
    const props = this.props;
    return (
      <div className={`ui-address ui-category ${props.visible ? 'active' : ''}`}>
        <div className="ui-address-content">
          <div className="ui-address-head">
            <p>选择应用分类</p>
            <span onClick={() => this.hideHandle()}>&times;</span>
          </div>
          <div className="ui-address-dt">
            <div className="ui-address-tab">
              <span className={props.tabIndex === 0 ? 'active' : ''} onClick={() => this.tabHandle(0)}>{props.lvList1[props.lvIndex1] ? props.lvList1[props.lvIndex1].classification_name : '请选择'}</span>
              { props.lvIndex1 > -1 && props.tabIndex > 0 ? <span className={props.tabIndex === 1 ? 'active' : ''} onClick={() => this.tabHandle(1)}>{props.lvList2[props.lvIndex2] ? props.lvList2[props.lvIndex2].classification_name : '请选择'}</span> : null }
              {props.lvIndex2 > -1 && props.tabIndex > 1 ? <span className={props.tabIndex === 2 ? 'active' : ''} onClick={() => this.tabHandle(2)}>{props.lvList3[props.lvIndex3] ? props.lvList3[props.lvIndex3].classification_name : '请选择'}</span> : null}
              { props.lvIndex3 > -1 && props.tabIndex > 2 ? <span className={props.tabIndex === 3 ? 'active' : ''} onClick={() => this.tabHandle(3)}>{props.lvList4[props.lvIndex4] ? props.lvList4[props.lvIndex4].classification_name : '请选择'}</span> : null }
            </div>
          </div>
          {
            props.tabIndex === 0 ?
            <div className="ui-address-dd">
              {
                props.lvList1.map((v: any, k: number) => {
                  return (
                    <p className={`${props.lvIndex1 === k ? 'active' : ''}`} key={`proItem-${v.id}`} onClick={() => this.selectItem(0, k)}>{v.classification_name}</p>
                  )
                })
              }
            </div>
            : null
          }

          {
            props.tabIndex === 1 ?
            <div className="ui-address-dd">
              {
                props.lvList2.map((v: any, k: number) => {
                  return (
                    <p className={`${props.lvIndex2 === k ? 'active' : ''}`} key={`cityItem-${v.id}`} onClick={() => this.selectItem(1, k)}>{v.classification_name}</p>
                  )
                })
              }
            </div>
            : null
          }
          {
            props.tabIndex === 2 ?
            <div className="ui-address-dd">
              {
                props.lvList3.map((v: any, k: number) => {
                  return (
                    <p className={`${props.lvIndex3 === k ? 'active' : ''}`} key={`distItem-${v.id}`} onClick={() => this.selectItem(2, k)}>{v.classification_name}</p>
                  )
                })
              }
            </div>
            : null
          }
          {
            props.tabIndex === 3 ?
            <div className="ui-address-dd">
              {
                props.lvList4.map((v: any, k: number) => {
                  return (
                    <p className={`${props.lvIndex4 === k ? 'active' : ''}`} key={`distItem-${v.id}`} onClick={() => this.selectItem(3, k)}>{v.classification_name}</p>
                  )
                })
              }
            </div>
            : null
          }
        </div>
      </div>
    )
  }
  /**
   * [选择省市区]
   * [选择省市区]
   * @param index [索引] 0 省 1市 2 区
   * @param k [项索引]
   * @param code [父级code码]
   */
  private async selectItem(index: number, k: number) {
    this.props.selectItem(index, k);
  }
  /**
   * [切换]
   * @param index 0 省 1 市 2 区
   */
  private tabHandle(index: number) {
    this.props.tabAction(index);
  }
  /**
   * [隐藏面板]
   */
  private hideHandle() {
    this.props.hideAction();
  }
}

const mapStateToProps = ( state: any ): ICategoryAppStoreState => {
    return {
        ...state.categoryAppReducers
    };
};

const mapDispatchToProps = ( dispatch: Dispatch<ICategoryAppAction> ) => {
    return bindActionCreators({ getData, selectItem, tabAction, hideAction }, dispatch);
};

export default connect( mapStateToProps, mapDispatchToProps )(CategoryApp);
